module.exports = __webpack_public_path__ + "static/media/addlocationn.7c86fdc7.png";